/**
 * /frontend/src/features/analytics/components/appointments/AppointmentVsWalkInChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import StackedBarChart from '../charts/StackedBarChart';

/**
 * Appointment vs walk-in comparison chart.
 * @param {{data:Array<{label:string,appointmentCompleted:number,walkInCompleted:number}>}} props
 * @returns {JSX.Element}
 */
const AppointmentVsWalkInChart = ({ data }) => {
  const stackKeys = useMemo(() => (['appointmentCompleted', 'walkInCompleted']), []);
  return (
    <ChartContainer title="Appointments vs Walk-ins" subtitle="Completed counts over time">
      <StackedBarChart
        data={data}
        xKey="label"
        stackKeys={stackKeys}
      />
    </ChartContainer>
  );
};

export default AppointmentVsWalkInChart;
